import { useMutation } from '@tanstack/react-query';

import type { OnboardingRecord } from '../types';

import { apiClient } from '@config/server/apiClient';
import { productOnboardingEndpoints } from '@config/server/apiEndpoints';

interface CreateOnboardingRecordParams {
	dealershipName: string;
	dealerWebsiteUrl: string;
	email: string;
	productType: 'access' | 'dealer';
	/** reCAPTCHA Enterprise token — sent as X-Recaptcha-Token header (matches existing auth pattern) */
	recaptchaToken: string;
}

export const useCreateOnboardingRecord = () =>
	useMutation({
		mutationFn: async ({ recaptchaToken, ...body }: CreateOnboardingRecordParams) => {
			const res = await apiClient.post<OnboardingRecord>(
				productOnboardingEndpoints.base(),
				body,
				{
					headers: {
						'X-Recaptcha-Token': recaptchaToken,
					},
				},
			);
			return res.data as OnboardingRecord;
		},
	});
